import { render } from "./Winners.vue?vue&type=template&id=7c6b8e85&scoped=true"
import script from "./Winners.vue?vue&type=script&lang=js"
export * from "./Winners.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7c6b8e85"

export default script